import { CheckStatus } from '@components/SiteUserUpload/types/uploadTypes';

export const getStatusColorClass = (status: CheckStatus): string => {
  const colorMap: Record<CheckStatus, string> = {
    [CheckStatus.NO_VALIDATED]: 'text-pastelBlue',
    [CheckStatus.LOADING]: '',
    [CheckStatus.RESOLVED]: 'text-honoluluBlue',
    [CheckStatus.SUCCESS]: 'text-yellowGreen',
    [CheckStatus.WARNING]: 'text-redOrange',
  };

  return colorMap[status] ?? 'text-defaultColor';
};
